<template>
    <transition name="animate">
        <div class="md site-tools">
            <ul>
                <li class="shopping" v-if="islogin && showCartList">
                    <a href="#" @click.stop.prevent="toggle" :title="$t('site.noun.cart')">
                        <span v-if="shoppingCartList.length">{{ shoppingCartList.length }}</span>
                    </a>
                </li>
                <li
                    v-if="islogin"
                    class="order"
                >
                    <a href="#" @click.stop.prevent="goOrder" :title="$t('site.noun.order')"></a>
                </li>
                <li
                    v-if="islogin"
                    class="favorite"
                >
                    <a href="#" @click.stop.prevent="goFavorite" :title="$t('site.noun.favorite')"></a>
                </li>
                <li class="search">
                    <router-link
                        :title="$t('site.noun.search')"
                        to="/system/search"
                    ></router-link>
                </li>
                <!-- <li
                    class="audio" :class="isPlayAudio ? '' : 'none' "
                >
                    <a href="#" @click.prevent="soundChange" :title="isPlayAudio ? $t('site.func.play') : $t('site.func.mute') "></a>
                </li> -->
                <li
                    v-if="$siteConfig.devEvent"
                    class="reload"
                >
                    <a href="#" @click.stop.prevent="reload" :title="$t('site.noun.reload')"></a>
                </li>
            </ul>
        </div>
    </transition>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        data: function(){
            
            return {
                top: 0
            }
        },
        computed: {
            ...mapState([
                'user',
                'shoppingCart',
                'isPlayAudio',
            ]),
            shoppingCartList: function(){
                return this.shoppingCart.filter(item => item.is_on_market);
            },
            showCartList: function(){
                return this.$route.path !== '/system/cartList';
            },
            islogin: function(){
                return this.user.sn;
            },
        },
        // watch: {
        //     isPlayAudio: {
        //         handler: function(){
        //             let $audio = document.querySelector('audio');
                    
        //             if (this.isPlayAudio) {
        //                $audio.play()
        //             }else{
        //                 $audio.pause();
        //             }
        //         },
        //     },
        // },
        methods: {
            ...mapMutations([
                'reload',
                // 'soundChange'
            ]),
            goOrder: function(){
                this.$router.push('/system/account?page=purchase&tab=3');
            },
            goFavorite: function(){
                this.$router.push('/system/account?page=favorite');
            },
            toggle: function(){
                this.$emit('sendEvent', 'toggleShoppingCart');
            },
            getTop: function(){
                this.top = window.pageYOffset;
            },
            toTop: function(){

                let $timer = window.setInterval(() => {
                    let _pos = window.pageYOffset;

                    if ( _pos > 0 ){
                        window.scrollTo( 0, Math.max(_pos - 20, 0) );
                    } else {
                        window.clearInterval($timer);
                    }
                }, 2);
            },
            priceForGoods: function(){
                let $shoppingCartList = this.shoppingCartList,
                    $value = 0,
                    $items = [];

                $shoppingCartList.forEach(item => {
                    let _customer_need_date = item.customer_need_date,
                        $date = new Date();

                    if( _customer_need_date ) {
                        $date = new Date(_customer_need_date);
                    }

                    let _date = $date.toLocaleDateString(),
                        _price = this.$siteTool.computedPrice(item, _date);
                    
                    item.price = _price;
                    $value += item.qty * item.price;
                    $items.push({
                        item_id: item.cart_sn,
                        item_name: item.product_s,
                        item_brand: "Formosa Plastic Corporation",
                        item_category: item.product_b,
                        item_category2: item.product_m,
                        item_category3: item.product_s,
                        price: item.price,
                        quantity: item.qty
                    })
                })

                return {
                    value: $value,
                    items: $items
                }
            },
            viewCart: function(){
                let goods = this.priceForGoods();

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                    event: "view_cart",
                    ecommerce: {
                        currency: "TWD",
                        value: goods.value,
                        items: goods.items
                    }
                });
            }
        },
    }
</script>

<style scoped lang="scss">

    .animate-enter-active {
        animation: animate-in 150ms;
    }

    .animate-leave-active {
        animation: animate-out 150ms;
    }

    @keyframes animate-in {
        0% {
            transform: scale(1.1);
            opacity: 0;
        }

        100% {
            transform: scale(1);
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .animate-enter-active {
        animation: animate-in .3s;
    }

    .animate-leave-active {
        animation: animate-out .2s;
    }

    @keyframes animate-in {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }
    
    .md.site-tools {
        position: fixed;
        right: $interval-m;
        top: 66px;
        line-height: 1;

        ul {
            @extend %reset;
        }

        li {
            position: relative;

            + li {
                margin-top: 4px;
            }

            &.reload {

                a {

                    &::before {
                        content: '\e5d5';
                    }
                }
            }

            &.shopping {

                a {

                    &::before {
                        content: '\e8cc';
                    }

                    span {
                        @extend %notification-span;
                        z-index: 1;
                    }
                }
            }

            &.search {

                a {

                    &::before {
                        content: '\e8b6';
                    }
                }
            }

            // &.audio{

            //     &.none {

            //         a {

            //             &::before {
            //                 content: '\e04f';
            //             }
            //         }
            //     }

            //     a {

            //         &::before {
            //             content: '\e050';
            //         }
            //     }
            // }

            &.order {

                a {

                    &::before {
                        content: '\ef6e';
                    }
                }
            }

            &.favorite {

                a {

                    &::before {
                        content: '\e87e';
                    }
                }
            }
        }

        a {
            transition: $transition;
            display: block;
            cursor: pointer;
            border-radius: $border-radius;
            background-color: rgba-set($minor-color, $opacity-h);

            &:hover {
                background-color: $forth-color;

                &::before {
                    color: $white;
                }
            }

            &::before {
                @extend %font-pseudo;
                line-height: $btnInput_h;
                font-size: $font-size-xxl;
                vertical-align: bottom;
                color: $forth-color;
                width: $btnInput_h;
                text-align: center;
                transition: $transition;
            }
        }
    }
</style>
